import React from 'react'
import { CUSTOMER_JOURNEYS } from '@/modules/Customer/constants'
import { useTranslation } from 'react-i18next'
import { Tooltip } from '@mui/material'
import dayjs from 'dayjs'

interface ContactExplainationProps {
    journeyStep?: string | null
    journeyStepStatus?: string | null
    lastNote?: string | null
    lastNoteAt?: string | null
}

const ContactExplaination: React.FC<ContactExplainationProps> = ({
    journeyStep,
    journeyStepStatus,
    lastNote,
    lastNoteAt,
}) => {
    const { t } = useTranslation()

    if (!journeyStep) return null

    const stepLabel =
        CUSTOMER_JOURNEYS(t)?.find((item) => item?.value === journeyStep)
            ?.label || journeyStep

    // Status indicator colors
    const statusColors: Record<string, string> = {
        pending: 'bg-gray-400',
        in_progress: 'bg-blue-500',
        completed: 'bg-green-500',
    }

    const noteContent = lastNote ? (
        <div className="text-xs">
            <div className="font-medium">{lastNote}</div>
            {lastNoteAt && (
                <div className="text-gray-400 mt-1">
                    {dayjs(lastNoteAt).format('DD/MM/YYYY HH:mm')}
                </div>
            )}
        </div>
    ) : null

    return (
        <Tooltip title={noteContent || ''} placement="top">
            <div className="flex items-center gap-1.5">
                {journeyStepStatus && (
                    <span
                        className={`w-1.5 h-1.5 rounded-full ${statusColors[journeyStepStatus] || 'bg-gray-400'}`}
                    />
                )}
                <span className="text-xs truncate">{stepLabel}</span>
            </div>
        </Tooltip>
    )
}

export default ContactExplaination
